import { type Enum } from '../../../../../react-commons/types/enum';
import { formatToPascalCase } from '../../../../../react-commons/utils/utilFunctions';
import { ApplicationVersion, formatMaestraSignalVersion } from '../ApplicationVersion';

export const getEnumFormatter = <E extends string>(enumType: Enum<E>): ((value: E) => string) => {
    return (() => {
        switch (enumType) {
            case ApplicationVersion:
                return formatMaestraSignalVersion;
            default:
                return formatToPascalCase;
        }
    })() as (value: E) => string;
};
